export const fillObject = (obj: Record<string, any>) => {
  let response: Record<string, any> = {};
  Object.entries(obj)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .forEach(([key, value]) => {
      response[key] = value;
    });
  return response;
};
